import { ENDPOINT } from '~/constants/endpoints';

import { UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { type SuppliersPriorityResponse } from './types';
import {
  zodSuppliersPriorityResponseSchema,
  zodSuppliersPrioritySearchParamsSchema,
} from './validations';

/**
 * Fetches the priority-ordered supplier list along with contingent metadata.
 *
 * @param recipientCompanyId - Recipient company ID.
 * @param options - Optional ky request options (e.g., abort signal).
 * @returns The suppliers priority response.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Supplier-overview/operation/get_suppliers_priority_suppliers_views_priority_get
 */
export const fetchSuppliersPriority = async (
  recipientCompanyId: UUID,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .get(ENDPOINT.SUPPLIER.GET_PRIORITY(), {
      ...options,
      searchParams: {
        recipientCompanyId,
      },
      validate: {
        ...options?.validate,
        response: zodSuppliersPriorityResponseSchema,
        searchParams: zodSuppliersPrioritySearchParamsSchema,
      },
    })
    .json<SuppliersPriorityResponse>();
